import React, {useContext, useEffect, useState} from "react";
import { ToastContainer, toast, useToast } from 'react-toastify';
import classNames from "classnames";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Button,
} from "reactstrap";
import { drizzleConnect } from '@drizzle/react-plugin';
import ReactTable from "components/ReactTable/ReactTable.js";
import { DrizzleContext, DrizzleProvider } from "@drizzle/react-plugin";
import { createJsxText, OperationCanceledException } from "typescript";
import coinAddressValidator from 'coin-address-validator';
import { newContextComponents } from "@drizzle/react-components";
import { AlbazeaInteractor, translateException } from "../../albazea/interactions";
import { AlbazeaContractStatus } from "../../components/Albazea/ContractStatus";
import { AlbazeaContractTimestamp } from "../../components/Albazea/ContractTimestamp";
import {isContractWithdrawable, isContractTerminable, isContractRenewable, printTime } from "../../albazea/albazeaUtils";
import logo from "../../assets/img/logo.png" ;
import logozea from "assets/img/logo.png"; //logo blanco de Albazea


const { AccountData } = newContextComponents;


const ViewCreatorContracts = (props) => {

  const {drizzle, drizzleState, initialized} =  useContext(DrizzleContext.Context);
  const interactor = new AlbazeaInteractor(drizzle);
  
  const getContractsByCreator =  async function () {
 
    let data = await interactor.getContractsByCreator(props.accounts[0]);
    return data;
}
  
  const [data, setData] = React.useState([]);

  const reload = async () => {    

    let data = await getContractsByCreator();

    let listData = data.map((prop, key) => {
    return {
      id: key,
      contractId: prop["id"],
      creator: prop["creator"],
      beneficiary: prop["beneficiary"],
      flexible: prop["flexible"] ?  "Flexible" : "Fijo",
      terminable: prop["terminable"] ?  "Cancelable" : "No cancelable",
      amount: drizzle.web3.utils.fromWei(prop["amount"]),
      status:  <AlbazeaContractStatus status={prop["status"]}/>,
      validityTime: printTime(prop["validityTime"]),
      lastUpdateTimestamp: <AlbazeaContractTimestamp timestamp={prop["lastUpdateTimestamp"]}/>,
      actions: (
        // we've added some custom button actions
        <div className="actions-right">
          
          {isContractRenewable(prop["status"], prop["flexible"]) && (
          <Button
            onClick={async () => {
              let obj = listData.find((o) => o.id === key);
              try {
                await interactor.faithOfLife(obj.contractId);
              } catch(err)  {
                return toast.error( translateException(err), { position: toast.POSITION.BOTTOM_RIGHT });                
              }
              reload();
            }}
            color="success"
            size="sm"
            className={classNames("btn-icon btn-link like", {})} >           
              <i className="tim-icons icon-heart-2" />
          </Button>
          )
          }
          
          {/* use this button to remove the data row */}
          {isContractTerminable(prop["status"], prop["terminable"]) && (
          <Button
            onClick={ async () => {
              let obj = listData.find((o) => o.id === key);
              try {
                await interactor.terminateContract(obj.contractId);
              } catch(err)  {
                return toast.error( translateException(err), { position: toast.POSITION.BOTTOM_RIGHT });                
              }
              reload();
            }}
            color="danger"
            size="sm"
            className={classNames("btn-icon btn-link like", {
              
            })}
          >
            <i className="tim-icons icon-simple-remove" />
          </Button>)}{" "}
        </div>
      ),
    };
  });

    console.log(data);
    
    setData(listData);
  

  }

  useEffect(() => {
    (async () => {
      reload();
    })();
  }, []);
  

  return (
    <>
      <div className="content">
        <Col md={8} className="ml-auto mr-auto">
        <h1 className="text-center"><img src={logo} style={{maxWidth:"180px"}} alt="zea"></img></h1>
        <h2 className="text-center">Mis Contratos</h2>
          <p className="text-center">
            En esta lista podrás ver todos tus contratos creados hasta la fecha y realizar las operaciones de gestión aplicables a cada uno de ellos.
          </p>
        </Col>
        <Row className="mt-5">
          <Col xs={12} md={12}>
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Mis contratos</CardTitle>
              </CardHeader>
              <CardBody>
                <ReactTable
                  data={data}
                  filterable
                  resizable={false}
                  columns={[
                    {
                      Header: "Id de contrato",
                      accessor: "contractId",
                    },
                    {
                      Header: "Beneficiario",
                      accessor: "beneficiary",
                    },
                    {
                      Header: "Balance Actual",
                      accessor: "amount",
                    },
                    {
                      Header: "Flexible o fijo",
                      accessor: "flexible",
                    },
                    {
                      Header: "Cancelable",
                      accessor: "terminable",
                    },
                    {
                      Header: "Duración en días",
                      accessor: "validityTime",
                    },
                    {
                      Header: "Última fecha de renovación",
                      accessor: "lastUpdateTimestamp",
                    },
                    {
                      Header: "Estado",
                      accessor: "status",
                    },
                    {
                      Header: "Acciones",
                      accessor: "actions",
                      sortable: false,
                      filterable: false,
                    },
                  ]}
                  defaultPageSize={10}
                  showPaginationTop
                  showPaginationBottom={false}
                  className="-striped -highlight"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

//export default ViewBeneficiary;
const mapStateToProps = state => {
  return {
    accounts: state.accounts,
    accountBalances: state.accountBalances,
    drizzleStatus: state.drizzleStatus,
    Albazea: state.contracts.Albazea,
    web3: state.web3
  }
}
const AppContainer = drizzleConnect(ViewCreatorContracts, mapStateToProps);
export default AppContainer;
